import { BodyText, H3 } from '@/shared/components/StyledText';
import { green, lightGreen } from '@/shared/styles/colors';
import styled from '@emotion/native';

export const PADDING_CONTAINER_HORIZONTAL = 32;

export const PaddingContainer = styled.View<{ marginBottom?: number }>(
  ({ marginBottom = 0 }) => ({
    width: '100%',
    paddingHorizontal: PADDING_CONTAINER_HORIZONTAL,
    marginBottom,
  }),
);

export const Title = styled(H3)<{ marginBottom?: number }>(
  ({ marginBottom = 8 }) => ({
    marginBottom,
    textAlign: 'center',
    textTransform: 'uppercase',
  }),
);

export const Label = styled(BodyText)<{ marginBottom?: number }>(
  ({ marginBottom = 0 }) => ({
    fontSize: 16,
    color: green,
    marginBottom,
    fontWeight: 400,
  }),
);

export const Subtitle = styled(BodyText)({
  fontSize: 16,
  textAlign: 'center',
  color: lightGreen,
});
